import styled from 'styled-components';

export const ContainerCheckout = styled.div`
  width: 100vw;
  min-height: 89.262vh;
  display: flex;
  flex: none;
  flex-direction: column;
  align-items: center;
  font-family: 'Libre Franklin', sans-serif;
`;

export const ContainerContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: none;
  width: 100vw;
  align-items: center;
`;

export const CheckoutComponent = styled.div`
  display: flex;
  flex: none;
  flex-direction: column;
  width: 89.333vw;
  margin-bottom: 5vw;
  align-items: center;
`;
